<template>
  <section>
    <div class="headP" :class="getHeadClass">
      <div class="headDiv" :class="[getHeadClass,selfHeadColor]">
        <router-link to="/">
          <img :src="getLogo"/>
        </router-link>
        <ul>
          <li @mouseenter="showSecondTab='product'" @mouseleave="showSecondTab=''">
            <span>产品信息</span>
            <div v-show="showSecondTab==='product'" class="secondTab">
              <div class="content" @click="showSecondTab=''">
                <div class="product headTab">
                  <router-link class="head_href" :to="{name: 'productDetail',query: {categoryId:146}}">
                    <img src="http://video.naolamp.com/images/index/pro_dh1.png"/>
                  </router-link>
                </div>
                <div class="product headTab">
                  <router-link class="head_href" :to="{name: 'productDetail',query: {categoryId:138}}">
                    <img src="http://video.naolamp.com/images/index/pro_dh2.png"/>
                  </router-link>
                </div>
                <div class="product headTab">
                  <router-link class="head_href" :to="{name: 'productDetail',query: {categoryId:137}}">
                    <img src="http://video.naolamp.com/images/index/pro_dh3.png"/>
                  </router-link>
                </div>
                <div class="product headTab">
                  <div class="head_href">
                    <img src="http://video.naolamp.com/images/index/pro_dh4.png"/>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <router-link to="/news">
              <span>新闻中心</span>
            </router-link>
          </li>
          <li>
            <router-link to="/article">
              <span>灯改论坛</span>
            </router-link>
          </li>
          <!--<li @mouseenter="showSecondTab='install'" @mouseleave="showSecondTab=''">
            <span>预约装灯</span>
            <div v-show="showSecondTab==='install'" class="secondTab">
              <div class="content" @click="showSecondTab=''">
                <div class="store headTab">
                  <router-link to="/install/storeSearch">
                    <div class="describe">
                      门店查询
                    </div>
                    <img src="http://video.naolamp.com/officialWeb/install/install_store.png"/>
                  </router-link>
                </div>
                <div class="car headTab">
                  <router-link to="/install/carSearch">
                    <div class="describe">
                      型号查询
                    </div>
                    <img src="http://video.naolamp.com/officialWeb/install/install_car.png"/>
                  </router-link>
                </div>
              </div>
            </div>
          </li>-->
          <li>
            <router-link to="/service">
              <span>质保售后</span>
            </router-link>
          </li>
            <li @mouseenter="showSecondTab='about'" @mouseleave="showSecondTab=''">
                <span>关于我们</span>
              <div v-show="showSecondTab==='about'" class="secondTab">
                <div class="content" @click="showSecondTab=''">
                  <div class="company headTab">
                    <router-link to="/about">
                      <div class="describe">
                        公司简介
                      </div>
                      <img src="http://video.naolamp.com/officialWeb/about/about_company.png"/>
                    </router-link>
                  </div>
                  <div class="join">
                    <div class="headTab">
                      <router-link to="/about/contact">
                        <div class="describe">
                          联系我们
                        </div>
                        <img src="http://video.naolamp.com/officialWeb/about/about_contact.png"/>
                      </router-link>
                    </div>
                    <div class="headTab">
                      <router-link to="/about/join">
                        <div class="describe">
                          加入我们
                        </div>
                        <img src="http://video.naolamp.com/officialWeb/about/about_join.png"/>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          <li>
            <router-link to="/internal">
              <span>内部入口</span>
            </router-link>
          </li>
        </ul>
        <div class="headBtn">
            <!--<div class="carImg" @click="goShoppingCar">
              <i class="iconfont icon-cart"></i>
              <span id="badge" v-if="carNum">{{getCount}}</span>
            </div>-->
          <!--<div class="loginDiv" @mouseenter="showLoginBtn=true" @mouseleave="showLoginBtn=true">-->
          <div class="loginDiv" @mouseenter="showSecondTab='login'" @mouseleave="showSecondTab=''">
            <i class="iconfont icon-account"></i>
            <!--<div class="loginBtn" v-show="showLoginBtn">-->
            <div class="loginBtn" v-show="showSecondTab==='login'">
              <div class="loginBtnDiv">
                <!--<img :src="cdsLogoB"/>-->
                <div v-if="!isLogin" @click="login">登录</div>
                <router-link to="/register">
                  <div v-if="!isLogin">注册</div>
                </router-link>
                <router-link to="/shoppingCar/orderList">
                  <div v-if="isLogin">我的订单</div>
                </router-link>
                <router-link to="/personalCenter">
                  <div v-if="isLogin">个人中心</div>
                </router-link>
                <div v-if="isLogin" @click="loginOut">退出</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as types from '../../common/js/types'
import {vm, COUNTSTR} from '../../common/js/vm.js'
vm.$on(COUNTSTR, function (count) {
  var badgeobj = document.querySelector('#badge')
  badgeobj.innerText = parseInt(badgeobj.innerText) + count
  localStorage.setItem('c', badgeobj.innerText)
})

export default {
  props: {
    headColor: {
      type: String,
      default: ''
    },
    countNum: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      userName: '游客',
      cdsLogoW: require('../../assets/icon/logo_w.png'),
      cdsLogoB: require('../../assets/icon/logo.png'),
      carCircle: require('../../assets/icon/car_circle.png'),
      showLoginBtn: false,
      isLogin: false,
      showSecondTab: '',
      carNum: null,
      count: 0,
      selfHeadColor: ''
    }
  },
  methods: {
    goShoppingCar () {
      if (!this.$root.getUserId()) {
        this.$router.push('/login')
      } else if (this.$root.getUserId()) {
        this.init()
        this.$router.push('/shoppingCar/shopCar')
      }
    },
    login: function () {
      localStorage.removeItem('redirect')
      // localStorage.setItem('redirect', this.$router.currentRoute.path)
      this.$router.push('/login')
    },
    loginOut: function () {
      this.isLogin = false
      this.$store.commit(types.LOGOUT)
      if (this.$router.currentRoute.meta.needAuth) {
        this.$router.push('/login')
      }
    },
    init: function () {
      this.carNum = 1
      if (localStorage.getItem('c')) {
        this.count = parseInt(localStorage.getItem('c'))
      } else {
        this.count = 0
      }
      if (localStorage.user) {
        let user = JSON.parse(localStorage.user)
        this.isLogin = localStorage.token
        this.userName = user.userName
      }
    }
  },
  mounted: function (s) {
    this.init()
  },
  computed: {
    getCount: function () {
      let that = this
      if (this.countNum === 'login' || this.countNum === 'accountAssociated' || this.countNum === 'shopCar') {
        that.count = parseInt(localStorage.getItem('c'))
        return this.count
      }
      return this.count
    },
    getHeadClass: function () {
      // { active: isActive, 'text-danger': hasError }
      return {backWhite: this.showSecondTab !== ''}
    },
    getLogo: function () {
      if (this.showSecondTab !== '') {
        return this.cdsLogoB
      } else {
        if (this.selfHeadColor === 'index') {
          return this.cdsLogoW
        } else {
          return this.cdsLogoB
        }
      }
    }
  },
  updated () {},
  watch: {
    'headColor': function () {
      this.selfHeadColor = this.headColor
    },
    '$store.state.headColor': function () {
      // 监控颜色改变
      this.selfHeadColor = this.$store.state.headColor
    }
  }
}
</script>

<style scoped>
.index {
  color: white;
}
.backWhite {
  color: black;
  background-color: white;
}
.headP {
  width: 100%;
  min-width: 1200px;
  z-index: 100;
  position: absolute;
}
.headDiv{
  margin: 0 auto;
  width: 1200px;
  height: 52px;
}
.headDiv img {
  float: left;
  padding: 8px 79.5px 0 10px;
  height: 36px;
}
.headDiv ul li {
  font-size: 14px;
  font-weight: 400;
  float: left;
  padding: 0;
  height: 52px;
  line-height: 52px;
}
.headDiv ul li span {
  padding: 0 22.5px;
}
.headDiv ul li span:hover {
  opacity: .6;
}
.secondTab {
  color: #333;
  z-index: 2;
  top: 51px;
  position: absolute;
  left: 0;
  width: 100%;
  min-width: 1200px;
  background-color: #F2F2F2;
  height: 450px;
}
.secondTab .content {
  top: 20px;
  left: 50%;
  position: absolute;
  margin-left: -600px;
  width: 1200px;
}
.secondTab img {
  padding: 0;
}
.secondTab .product {
  float: left;
}
.secondTab .product .head_href  img{
  height: 395px;
  width: 286px;
  float: left;
  margin-right: 18px;
}
.secondTab .product:last-child .head_href img{
  margin-right: 0;
}
.secondTab .store,.secondTab .car{
  width: 590px;
  float: left;
}
.secondTab .store {
  margin-right: 20px;
}
.secondTab .store img,.secondTab .car img{
  height: 390px;
  width: 590px;
  float: left;
}
.describe {
  position: absolute;
}
.secondTab .store .describe,.secondTab .car .describe{
  width: 590px;
}
.secondTab .company img {
  height: 390px;
  width: 700px;
  float: left;
}
.secondTab .company {
  width: 700px;
  height: 390px;
  float: left;
  margin-right: 20px;
}
.secondTab .company .describe{
  width: 700px;
  color: #333;
}
.secondTab .join {
  height: 390px;
  width: 480px;
  float: left;
}
.secondTab .join img {
  height: 190px;
  width: 480px;
  float: left;
}
.secondTab .join .headTab {
  width: 480px;
  height: 190px;
}
.secondTab .join .headTab:first-child {
  margin-bottom: 10px;
}
.secondTab .join .describe {
  margin-top: 60px;
  width: 150px;
}
.secondTab .headTab:hover {
  opacity: .7;
}
.headBtn {
  float: right;
}
.headBtn div {
  float: left;
  line-height: 50px;
}
.carImg {
  padding-right: 80px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.iconfont {
  font-size: 20px;
}
/*.carImg img {*/
  /*z-index: -1;*/
  /*top: 10px;*/
  /*width: 16px;*/
  /*height: 16px;*/
  /*position: absolute;*/
/*}*/
.carImg>span {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  background-color: #00bf73;
  border-radius: 50%;
  font-size: 10px;
  margin-left: 4px;
  text-align: center;
  cursor: pointer;
}
.headBtn span {
  color: #FFFFFF;
}
.loginDiv {
  padding-right: 10px;
}
.loginBtn {
  color: black;
  z-index: 2;
  position: absolute;
  padding: 0;
  margin: 0;
}
.loginBtnDiv {
  width: 90px;
  position: absolute;
  right: -27px;
}
.loginBtnDiv img {
  padding: 0;
  line-height: 10px;
  width: 90px;
  height: 10px;
  float: none;
  display: block;
}
.loginBtnDiv div {
  float: none;
  background-color: #FFFFFF;
  margin: 0;
  line-height: 45px;
  height: 45px;
  border-bottom: 1px solid #EBEFF2;
}
.loginBtnDiv div:hover {
  background-color: #EBEFF2;
}
</style>



// WEBPACK FOOTER //
// src/components/common/indexHeader.vue